import { BillingType, BillStatus, FetchPreBillsQuery } from '../../../../generated'

export enum PreBillsSortBy {
  Date = 'date',
  MatterId = 'matterId',
  ClientId = 'clientId'
}

export enum PreBillsSortDir {
  Asc = 'asc',
  Desc = 'desc'
}

export interface PreBillsFilters {
  attorneyId?: string
  lawTypeId?: string
  caseType?: BillingType
  status?: BillStatus
  searchTerm?: string
  billDeliveryType?: string
  sortBy?: PreBillsSortBy
  sortDir?: PreBillsSortDir
  onlyWithTrust?: boolean
  onlyWithCredit?: boolean
}

export interface PreBillsState {
  preBills: NonNullable<FetchPreBillsQuery['fetchPreBills']['preBills']>
  loading: boolean
}

export const preBillsInitialState: PreBillsState = {
  preBills: [],
  loading: false
}

export enum PreBillsActionType {
  SET_PRE_BILLS = 'setPreBills',
  SET_LOADING = 'setLoading'
}

export type PreBillsAction =
  | { type: PreBillsActionType.SET_PRE_BILLS; preBills: NonNullable<FetchPreBillsQuery['fetchPreBills']['preBills']> }
  | { type: PreBillsActionType.SET_LOADING; loading: boolean }

export const preBillsReducer = (state: PreBillsState, action: PreBillsAction): PreBillsState => {
  switch (action.type) {
    case PreBillsActionType.SET_PRE_BILLS:
      return {
        ...state,
        preBills: action.preBills
      }

    case PreBillsActionType.SET_LOADING:
      return {
        ...state,
        loading: action.loading
      }

    default:
      return state
  }
}
